import { render, staticRenderFns } from "./Topic2SideNav.vue?vue&type=template&id=87e03610&scoped=true"
import script from "./Topic2SideNav.vue?vue&type=script&lang=js"
export * from "./Topic2SideNav.vue?vue&type=script&lang=js"
import style0 from "./Topic2SideNav.vue?vue&type=style&index=0&id=87e03610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e03610",
  null
  
)

export default component.exports